import React, { useState } from 'react';
import { Bug } from 'lucide-react';
import BugReportModal from './BugReportModal';

const FloatingBugButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 group flex items-center gap-2 px-3 py-2.5 sm:px-4 sm:py-3 rounded-full bg-rose-600 hover:bg-rose-700 text-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 active:scale-95"
        aria-label="Signaler un bug"
      >
        <Bug className="w-5 h-5" strokeWidth={2} />
        <span className="text-sm font-medium hidden sm:inline">Signaler un bug</span>
      </button>

      <BugReportModal open={open} onOpenChange={setOpen} />
    </>
  );
};

export default FloatingBugButton;
